import {
  Flex,
  SimpleGrid,
  Box,
  Text,
  Icon,
  Progress,
  Square,
  Spacer,
  Center,
  useBreakpointValue,
  CircularProgress,
} from "@chakra-ui/react";
import { Calendar, Badge } from "rsuite";
import "rsuite/styles/index.less";

import { Header } from "../../components/Header";
import { Sidebar } from "../../components/Sidebar";
import { BiUser } from "react-icons/bi";
import { BiSupport } from "react-icons/bi";
import { ImFilesEmpty } from "react-icons/im";
import { useEffect, useState } from "react";
import { api } from "../../services/api";

import { useToast } from "@chakra-ui/react";

interface IData {
  users: number;
  events: number;
}

export default function Dashboard() {
  const toast = useToast();
  const isMobileVersion = useBreakpointValue({
    base: false,
    md: true,
  });

  const [loading, setLoading] = useState(true);

  const [data, setData] = useState<IData>({} as IData);

  useEffect(() => {
    async function loadDashboard() {
      try {
        const response = await api.get("/dashboard/data");
        setData(response.data);
      } catch (error) {
        toast({
          title: "Erro",
          description: "Falha ao carregar dados dos indicadores",
          status: "error",
          duration: 3000,
          isClosable: true,
        });
      } finally {
        setLoading(false);
      }
    }

    loadDashboard();
  }, []);

  return (
    <Flex direction="column" h="100%" w="100%" bg="bg" pb="5">
      <Header />

      <Flex w="100%" maxWidth={1480} px={isMobileVersion ? "10" : "3"} h="100%">
        <Sidebar />

        <Flex
          w="100%"
          justify="space-between"
          align={isMobileVersion ? "normal" : "center"}
          gap="10"
          direction={isMobileVersion ? "row" : "column"}
        >
          <Flex
            w="100%"
            maxWidth="390px"
            gap="10"
            direction="column"
            justify="center"
            align="center"
          >
            <Box bg="gray" boxShadow="md" w="100%" h={95} borderRadius={8}>
              <Flex h="95">
                <Center h="100%" w="130px" borderRight="2px solid #7f8489">
                  <Icon as={BiSupport} w={53} h={53} color="white" />
                </Center>

                <Spacer />

                <Flex align="end" direction="column" mr="5" mt="4">
                  <Text fontSize="28" color="green_primary">
                    0
                  </Text>

                  <Text fontSize="13" mb="4" color="text" lineHeight="0.7">
                    Chamados em aberto
                  </Text>
                </Flex>
              </Flex>
            </Box>

            <Box bg="gray" boxShadow="md" w="100%" h={95} borderRadius={8}>
              <Flex h="95">
                <Center h="100%" w="130px" borderRight="2px solid #7f8489">
                  <Icon as={BiUser} w={53} h={53} color="white" />
                </Center>

                <Spacer />

                <Flex align="end" direction="column" mr="5" mt="4">
                  {loading ? (
                    <CircularProgress
                      thickness="4px"
                      size="28px"
                      color="green_primary"
                      isIndeterminate
                    />
                  ) : (
                    <Text fontSize="28" color="green_primary">
                      {data.users}
                    </Text>
                  )}

                  <Text fontSize="13" mb="4" color="text" lineHeight="0.7">
                    Usuários ativos
                  </Text>
                </Flex>
              </Flex>
            </Box>

            <Box bg="gray" boxShadow="md" w="100%" h={95} borderRadius={8}>
              <Flex h="95">
                <Center h="100%" w="130px" borderRight="2px solid #7f8489">
                  <Icon as={ImFilesEmpty} w={53} h={53} color="white" />
                </Center>

                <Spacer />

                <Flex align="end" direction="column" mr="5" mt="4">
                  {loading ? (
                    <CircularProgress
                      thickness="4px"
                      size="28px"
                      color="green_primary"
                      isIndeterminate
                    />
                  ) : (
                    <Text fontSize="28" color="green_primary">
                      {data.events}
                    </Text>
                  )}

                  <Text fontSize="13" mb="4" color="text" lineHeight="0.7">
                    Total de registros
                  </Text>
                </Flex>
              </Flex>
            </Box>
          </Flex>

          <Box
            bg="gray"
            boxShadow="md"
            maxW="360px"
            flexShrink="0"
            height="410px"
            borderRadius={8}
            color="text"
            p={"2"}
            mr={"2"}
          >
            <div style={{}}>
              <Calendar compact />{" "}
            </div>
          </Box>
        </Flex>
      </Flex>
    </Flex>
  );
}
